<template>
  <div>
    <div class="row d-flex mt-2">
      <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12">
        <div class="input-group input-group-sm mb-3">
          <span class="input-group-text col-lg-3 col-md-5">Marca</span>
          <v-select
            ref="brand"
            :options="lstBrand"
            class="form-control form-control-sm"
            :reduce="(name) => name.id"
            label="name"
            placeholder="-- Seleccione una marca --"
            required
            v-model="filter.brand"
          />
        </div>
      </div>
      <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12">
        <div class="input-group input-group-sm mb-3">
          <span class="input-group-text col-lg-3 col-md-5">Clasificación</span>
          <v-select
            ref="brand"
            :options="lstSubcategorie"
            class="form-control form-control-sm"
            :reduce="(name) => name.id"
            label="name"
            placeholder="-- Seleccione una clasificación --"
            required
            v-model="filter.subategorie"
          />
        </div>
      </div>
      <div class="col-md-1 col-lg-1 col-sm-12 col-xs-12 mt-2">
        <button class="w-100 btn btn-sm btn-primary" @click="mtdGetData">
          <i class="fas fa-search"></i>
        </button>
      </div>
      <div class="col-md-3 col-lg-3 col-sm-12 col-xs-12 mt-2">
        <button class="w-100 btn btn-sm btn-primary" @click="mtdOpenModal">
          <i class="fas fa-plus"></i> Agregar montaje - luna
        </button>
      </div>
      <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 mt-2">
        <table class="table table-bordered">
          <thead>
            <tr style="text-align: center; vertical-align: middle">
              <th>DISEÑO</th>
              <th>MATERIALES</th>
              <th>RANGOS</th>
              <th class="vertical-text" style="font-weight: bold">UV</th>
              <th class="vertical-text" style="font-weight: bold">
                AZUL<br />
                LUZ
              </th>
              <th>COLORES</th>
              <th>SIMPLE</th>
              <th>TRIDUREX</th>
              <th>AR NOX</th>
              <th>AR DEVA BLUE</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in processedData" :key="index">
              <td
                style="text-align: center; vertical-align: middle"
                v-if="item.span.desing > 0"
                :rowspan="item.span.desing"
              >
                {{ item.desing }}
              </td>
              <td>{{ item.material }}</td>
              <td
                style="vertical-align: middle; text-align: center"
                v-if="item.span.rangos > 0"
                :rowspan="item.span.rangos"
              >
                {{ item.rangos }}
              </td>
              <td style="text-align: center; vertical-align: middle">
                <span v-if="item.filtroUv == 1">
                  <i class="fas fa-check"></i
                ></span>
              </td>
              <td style="text-align: center; vertical-align: middle">
                <span v-if="item.filtroLuzAzul == 1">
                  <i class="fas fa-check"></i
                ></span>
              </td>
              <td class="text-center align-middle">
                <div class="d-flex justify-content-center align-items-center" v-if="item.color && item.color.length > 0">
                  <template v-for="(group, index) in getColorGroups(item.color)" >
                    <div class="color-circle me-2">
                      <template v-for="(color, idx) in group" >
                        <div
                          class="color-half"
                          :class="idx === 0 ? 'left' : 'right'"
                          :style="{ backgroundColor: color }"
                          v-if="group.length === 2"
                        ></div>
                        <div
                          v-else
                          class="w-100 h-100"
                          :style="{ backgroundColor: color }"
                        ></div>
                      </template>
                    </div>
                  </template>
                </div>
              </td>
              <td v-for="(pre, ind) in item.precios" :key="ind">{{ pre.price }}</td>
              <!-- <td>{{ item. }}</td>
                <td>{{ item. }}</td>
                <td>{{ item. }}</td>
                <td>{{ item. }}</td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <CModalSubsubTrimax
      :title="modal.title"
      :boo_modal="modal.modal_form"
      @mtdCloseModal="mtdCloseModal"
      :id="modal.id"
      :lstDesing="lstDesing"
      :lstMaterial="lstMaterial"
      :lstRango="lstRango"
      :lstColor="lstColor"
      @mtdStoreTrimax="mtdStoreTrimax"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import CModalSubsubTrimax from "./modals/cModalSubsubTrimax.vue";

export default {
  name: "c-trimax",
  components: { CModalSubsubTrimax },
  data() {
    return {
      filter: {
        laboratory: 1,
        brand: null,
        subategorie: null,
      },
      data: [],
      modal: {
        title: "",
        modal_form: false,
        id: 0, // si es diferente de 0 es para editar el registro
        brand: "", // marca seleccionada
        subca: "", // subca seleccionada
      },
    };
  },
  props: {
    lstBrand: {
      default: () => [],
    },
    lstSubcategorie: {
      default: () => [],
    },
    lstDesing: {
      default: () => [],
    },
    lstMaterial: {
      default: () => [],
    },
    lstRango: {
      default: () => [],
    },
    lstColor: {
      default: () => [],
    },
  },
  computed: {
    processedData() {
      return this.data.length > 0 ? this.mtdCastCell(this.data) : [];
    },
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdGetData: function () {
      this.post({
        url: this.$store.getters.get__url + "/montaje/getdata",
        token: this.$store.getters.get__token,
        params: this.filter,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.data = response.data;
          }
        })
        .catch((errors) => {
          this.$refs.SweetAlert.showError(errors);
        });
    },
    mtdCastCell: function (data) {
      let merged = data.map((row) => ({
        ...row,
        span: { desing: 1, rangos: 1 }, // Solo afecta a `desing` y `rangos`
      }));

      ["desing", "rangos"].forEach((col) => {
        let lastValue = null,
          lastIndex = -1;
        for (let row = 0; row < data.length; row++) {
          if (data[row][col] === lastValue) {
            merged[row].span[col] = 0; // Oculta la celda
            merged[lastIndex].span[col]++; // Aumenta rowspan en la celda original
          } else {
            lastValue = data[row][col];
            lastIndex = row;
          }
        }
      });

      return merged;
    },
    mtdOpenModal: function () {
      let nameBrand = this.lstBrand.filter((br) => br.id == this.filter.brand);
      let nameSubca = this.lstSubcategorie.filter(
        (br) => br.id == this.filter.subategorie
      );

      this.modal.title =
        "AGREGAR MONTAJE: MARCA " +
        nameBrand[0].name +
        " CLASIFICACIÓN " +
        nameSubca[0].name;
      this.modal.modal_form = true;
    },
    mtdCloseModal: function () {
      this.modal.modal_form = false;
    },
    mtdStoreTrimax: function (payload) {
      payload.brand = this.filter.brand;
      this.post({
        url: this.$store.getters.get__url + "/montaje/store/trimax",
        token: this.$store.getters.get__token,
        params: payload,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.data = response.data;
            this.mtdCloseModal();
            this.mtdGetData();
            Swal.fire({
              text: "REGISTRADO CORRECTAMENTE!!",
              icon: "success",
              // width: "400px",
              confirmButtonColor: "rgb(67,81,122)",
            });
          }
        })
        .catch((errors) => {
          this.$refs.SweetAlert.showError(errors);
        });
    },
    getColorGroups(colors) {
        let groups = [];
        let length = colors.length;

        if (length === 1) {
          groups = [[colors[0]]];
        } else if (length === 2) {
          groups = [[colors[0]], [colors[1]]];
        } else if (length === 3) {
          groups = [[colors[0]], [colors[1]], [colors[2]]];
        } else if (length === 4) {
          groups = [[colors[0], colors[1]], [colors[2], colors[3]]];
        } else if (length === 5) {
          groups = [[colors[0], colors[1]], [colors[2], colors[3]], [colors[4]]];
        } else if (length === 6) {
          groups = [[colors[0], colors[1]], [colors[2], colors[3]], [colors[4], colors[5]]];
        } else if (length === 7) {
          groups = [[colors[0], colors[1]], [colors[2], colors[3]], [colors[4], colors[5]], [colors[6]]];
        }

        return groups;
      },
  },
};
</script>

<style scoped>
.vertical-text {
  writing-mode: vertical-rl; /* Texto en vertical de derecha a izquierda */
  text-orientation: upright; /* Mantiene los caracteres en posición normal */
}
.color-circle {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-block;
  border: 1px solid #000;
  overflow: hidden;
  position: relative;
}

.color-half {
  position: absolute;
  width: 50%;
  height: 100%;
  top: 0;
}

.left {
  left: 0;
}

.right {
  right: 0;
}
</style>